import { call, put, takeEvery } from 'redux-saga/effects'
import * as heThongApi from '@api/heThongApi'
import * as heThongActions from '@redux/ducks/heThongDucks'

function* fetchListHeThong(action: any) {
  try {
    const { queryString } = action.payload
    const res: ReturnType<typeof heThongApi.getListHeThong> = yield call(heThongApi.getListHeThong, queryString)
    yield put(heThongActions.getListHeThongSuccess(res))
  } catch (error) {
    yield put(heThongActions.getListHeThongFail(error))
  }
}

function* fetchDetailHeThong(action: any) {
  try {
    const { id } = action.payload
    const res: ReturnType<typeof heThongApi.getDetailHeThong> = yield call(heThongApi.getDetailHeThong, id)
    yield put(heThongActions.getDetailHeThongSuccess(res))
  } catch (error) {
    yield put(heThongActions.getDetailHeThongFail(error))
  }
}

export default function* heThongSaga() {
  yield takeEvery(heThongActions.getListHeThong.toString(), fetchListHeThong)
  yield takeEvery(heThongActions.getDetailHeThong.toString(), fetchDetailHeThong)
} 